'use es6';

import * as actionTypes from '../actions/actionTypes';
import { FETCH_CONTENT_SCHEMA_SUCCEEDED, FETCH_EDITABLE_SLUG_INFO_SUCCESS } from 'ContentEditorUI/redux/actions/actionTypes';
import { fromJS, List, Map as ImmutableMap, OrderedMap } from 'immutable';
import { findSuccessfulSocialAutoPublishDate } from '../../utils';
import { isTemporarySlug } from 'ContentEditorUI/utils/contentModelURLUtils';
const initialState = fromJS({
  createAuthorModalOpen: false,
  featuredImageThumbnailUrls: ImmutableMap(),
  notificationEmails: List(),
  showAllErrors: false,
  scrollToElement: '',
  socialAccounts: List(),
  socialAutoPublishingMessage: '',
  socialAutoPublishStatus: ImmutableMap(),
  customizeTitleEnabled: false,
  blogs: List(),
  tags: List(),
  tagsOptionsTotal: 0,
  blogListingPages: List(),
  listingTemplatePath: undefined
});
const postSettingsReducer = (state = initialState, {
  type,
  payload,
  response
}) => {
  switch (type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        // eslint-disable-next-line camelcase
        const {
          content,
          content_group
        } = response;
        return state.merge({
          dailyNotificationEmailId: content_group.dailyNotificationEmailId,
          enableSocialAutoPublishing: content_group.enableSocialAutoPublishing,
          instantNotificationEmailId: content_group.instantNotificationEmailId,
          monthlyNotificationEmailId: content_group.monthlyNotificationEmailId,
          weeklyNotificationEmailId: content_group.weeklyNotificationEmailId,
          blogPublishToSocialMediaTask: content.blogPublishToSocialMediaTask,
          shouldSyncTitleSlug: content.slug ? isTemporarySlug(content.slug) : false,
          listingTemplatePath: content_group.listingTemplatePath
        });
      }
    case actionTypes.FETCH_POST_AVAILABLE_AUTHORS_SUCCEEDED:
      {
        const {
          objects,
          selectedAuthor
        } = payload;
        let combinedAuthors = objects.reduce((acc, author) => acc.set(author.id, fromJS(author)), OrderedMap());
        if (selectedAuthor) {
          combinedAuthors = combinedAuthors.set(selectedAuthor.id, fromJS(selectedAuthor));
        }
        return state.set('availableAuthors', combinedAuthors.toList());
      }
    case actionTypes.FETCH_POST_TAGS_SUCCEEDED:
      {
        const {
          objects,
          total,
          selectedTagList,
          selectedTagIds
        } = payload;
        let combinedTags = objects.reduce((acc, {
          id,
          name,
          language
        }) => acc.set(id, ImmutableMap({
          id,
          name,
          language
        })), OrderedMap());
        combinedTags = selectedTagList.reduce((acc, tag) => selectedTagIds.includes(tag.id) ? acc.set(tag.id, fromJS(tag)) : acc, combinedTags);
        return state.merge({
          tags: combinedTags.toList(),
          tagsOptionsTotal: total
        });
      }
    case actionTypes.FETCH_POST_BLOGS_SUCCEEDED:
      return state.set('blogs', fromJS(payload.objects));
    case actionTypes.FETCH_POST_BLOGS_FAILED:
      return state.set('blogs', List());
    case actionTypes.FETCH_POST_NOTIFICATIONS_EMAILS_SUCCEEDED:
      return state.set('notificationEmails', fromJS(payload.objects));
    case actionTypes.FETCH_POST_SOCIAL_AUTO_PUBLISHING_SUCCEEDED:
      return state.set('socialAutoPublishingMessage', fromJS(payload.body));
    case actionTypes.FETCH_POST_SOCIAL_ACCOUNTS_SUCCEEDED:
      return state.set('socialAccounts', fromJS(payload));
    case actionTypes.FETCH_SOCIAL_AUTO_PUBLISH_STATUS_SUCCEEDED:
      return state.set('socialAutoPublishStatus', fromJS(payload));
    case actionTypes.FETCH_SOCIAL_BROADCASTS_SUCCEEDED:
      return state.set('successfulSocialAutoPublishDate', findSuccessfulSocialAutoPublishDate(fromJS(payload)));
    case actionTypes.UPDATE_POST_SETTINGS_SHOW_ALL_ERRORS:
      return state.set('showAllErrors', payload);
    case actionTypes.SET_SETTINGS_SCROLL_TO:
      return state.set('scrollToElement', payload);
    case actionTypes.UPDATE_POST_SETTINGS_SYNC_TITLE_SLUG:
      return state.set('shouldSyncTitleSlug', payload);
    case actionTypes.UPDATE_POST_SETTINGS_CUSTOMIZE_TITLE_ENABLED:
      return state.set('customizeTitleEnabled', payload);
    case actionTypes.CREATE_POST_AUTHOR_SUCCEEDED:
      return state.set('createAuthorModalOpen', false);
    case actionTypes.UPDATE_POST_CREATE_AUTHOR_MODAL_OPEN:
      return state.set('createAuthorModalOpen', payload);
    case actionTypes.CREATE_POST_TAG_SUCCEEDED:
    case actionTypes.CREATE_POST_TAG_TRANSLATION_SUCCEEDED:
      return state.set('tags', state.get('tags').push(fromJS(payload)));
    case actionTypes.UPDATE_POST_SETTINGS_SOCIAL_AUTO_PUBLISHING_FIELD:
      return state.set('socialAutoPublishingMessage', payload);
    case actionTypes.FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_SUCCEEDED:
      return state.set('featuredImageThumbnailUrls', ImmutableMap(payload));
    case FETCH_EDITABLE_SLUG_INFO_SUCCESS:
      return state.set('slugRaw', payload.editableSlug);
    case actionTypes.UPDATE_POST_CONTENT_MODEL_SLUG:
      return state.merge({
        slugRaw: payload.slugRaw,
        shouldSyncTitleSlug: !payload.slugRaw && !payload.htmlTitle || state.get('shouldSyncTitleSlug')
      });
    case actionTypes.FETCH_BLOG_LISTING_PAGES_SUCCEEDED:
      return state.set('blogListingPages', fromJS(payload.objects));
    default:
      return state;
  }
};
export default postSettingsReducer;